import { User } from 'contexts/base'
import { WebAdminUser, SupportUserPermission } from '../api'

export const determineDefaultPhone = (user: User) => {
  if (user.phone) return user.phone

  if (user.phones && user.phones.length > 0 && user.phones[0].number)
    return user.phones[0].number

  return ''
}

export const determineDefaultEmail = (user: User) => {
  if (user.email) return user.email

  if (user.emailAddresses && user.emailAddresses.length > 0)
    return user.emailAddresses[0].email ?? ''

  return ''
}

export const hasOneOfPermissions = (
  user: WebAdminUser | null,
  permissions: SupportUserPermission[],
) => {
  if (user === null || !user.isSupport || !user.permissions) return false

  return permissions.reduce((prev, current) => {
    return prev || user.permissions.includes(current)
  }, false)
}
